export default __webpack_public_path__ + "static/media/64.b7610feb.png";